import React from 'react';
import { META_ANALYSIS_TABS } from '../metaNavigation';
import MetaAudienceView from './MetaAudienceView';
import MetaInteractionsView from './MetaInteractionsView';
import MetaPlatformsView from './MetaPlatformsView';
import MetaReportContent from './MetaReportContent';
import MetaSectionLayout from './MetaSectionLayout';

// Subvistas de la fase 1 (Análisis e Informe): encabezado fijo + lista que scrollea.

/**
 * Análisis: toggle Público · Plataformas · Interacciones + período + campaña. Solo la vista elegida
 * está montada, así que solo ella hace sus pedidos.
 */
export function MetaAnalysisView({
  analysisTab, onAnalysisTabChange, campaigns, scopeCampaignId, onScopeChange, period, ownerUserId = null, includeInactive = false, ...layout
}) {
  const content = { campaigns, scopeCampaignId, period, ownerUserId };
  return (
    <MetaSectionLayout
      testId="meta-analysis"
      toggle={{ options: META_ANALYSIS_TABS, value: analysisTab, onChange: onAnalysisTabChange, ariaLabel: 'Tipo de análisis' }}
      scope={{ campaigns, value: scopeCampaignId, onChange: onScopeChange }}
      {...layout}
    >
      {analysisTab === 'platforms' ? <MetaPlatformsView {...content} /> : null}
      {analysisTab === 'interactions' ? <MetaInteractionsView {...content} /> : null}
      {analysisTab !== 'platforms' && analysisTab !== 'interactions' ? <MetaAudienceView {...content} includeInactive={includeInactive} /> : null}
    </MetaSectionLayout>
  );
}

/** Informe: todo el espacio en el período elegido (sin selector de campaña) + el informe de cada propiedad. */
export function MetaReportView({ period, periodPreset, ownerUserId = null, includeInactive = false, afterSummary = null, ...layout }) {
  return (
    <MetaSectionLayout testId="meta-report" periodPreset={periodPreset} {...layout}>
      <MetaReportContent period={period} periodPreset={periodPreset} ownerUserId={ownerUserId} includeInactive={includeInactive} afterSummary={afterSummary} />
    </MetaSectionLayout>
  );
}
